import{useContext as r}from"react";import{PrivyContext as t}from"./privy-context.mjs";import"./index.mjs";const o=()=>{let{isModalOpen:o}=r(t);return{isOpen:o}};export{o as useModalStatus};
